.amount {
  font-weight: 500;
}

.actionContainer {
  display: flex;
  flex-direction: column;
  text-align: right;
}
